import React from 'react'
import styled from 'styled-components'
import media from '~/lib/media'
import MainContentLayout from '~/components/templates/MainContentLayout'

export default function DefaultPageLayout({ children }: { children: React.ReactNode }) {
  return (
    <Container>
      <MainContentLayout>{children}</MainContentLayout>
    </Container>
  )
}

const Container = styled.div`
  box-sizing: content-box;
  margin: 0 auto;
  padding: 0 24px;
  max-width: 640px;
  min-width: 327px;

  ${media.greaterThan('desktopWide')`
    padding: 0 72px;
  `}
`
